<script lang="ts" setup>
import BaseDashboardPage from '@/components/base/BaseDashboardPage.vue'
</script>

<template>
  <BaseDashboardPage
    :title="$t('dashboard.admin.home.title')"
    :subtitle="$t('dashboard.admin.home.subtitle')"
    icon="mdi-shield-crown"
    icon-color="amber"
  >
    <p>{{ $t('dashboard.admin.home.title') }}</p>
  </BaseDashboardPage>
</template>
